<template>
   <div class="head_bg"><img src="../assets/head_bg.png" alt="罐区" /></div>
  <div class="hello" style="padding: 0.4rem; padding-top: 0.05rem">
   
    <div class="article">
      <div class="title_tip">
        <div class="title_top">
          <div class="title_left">概述</div>
          <div class="title_right">
            <div>COMPANY</div>
            <div>OVERVIEW</div>
          </div>
        </div>
        <div class="title_bottom"></div>
      </div>
      <div class="substance">
        <p>
          广州南沙弘达仓储有限公司致力于为国内外广大客户提供专业的石化产品仓储物流服务，同时，通过发挥股股东方的资源优势和协同效应，依托现有优质设施资源和条件，极力打造华南区区域一流的综合能源集散地。
        </p>
        <p>
          广州南沙弘达仓储库容总体规划为180万立方米，现已投产运营的一期、二期，三期罐容达91.83万立方米，主要分为燃料油、成品油、精细化工品三大板块;储罐罐型齐全，从最小850立方米罐型到最大3万立方米罐型，共计126个石化储罐，可满足重油(如燃料油、油浆)、汽柴油、生物柴油、苯类、醇类等数十种常见石油化工产品的高效装卸及存储。
        </p>
      </div>
    </div>

    <div class="article">
      <div class="container">
        <!-- Flex 项目 C -->
        <div class="item"><img src="../assets/3.png" /></div>
        <!-- Flex 项目 D -->
        <div class="item"><img src="../assets/4.png" /></div>
        <!-- Flex 项目 E -->
        <div class="item"><img src="../assets/5.png" /></div>
        <!-- Flex 项目 F -->
        <div class="item"><img src="../assets/6.png" /></div>
      </div>
    </div>

    <div class="article">
      <div class="title_tip">
        <div class="title_top">
          <div class="title_left">区域优势</div>
          <div class="title_right">
            <div>REGION</div>
            <div>ADVANTAGE</div>
          </div>
        </div>
        <div class="title_bottom"></div>
      </div>

      <div class="article_content_p">
        <p>
          广州南沙弘达仓储有限公司位于南沙小虎岛，独具宝贵的天然深水岸线资源和优良建港条件，地处粤港澳大湾区核心位置，毗邻港澳，连接深圳、中山、佛山、东莞、珠海等珠三角经济发达地区，水陆交通条件优越。元亨仓储以其优良码头储罐设施，为客户提供优质仓储服务。
        </p>
        <p>
          公司配套使用广州小虎石化码头，码头平面呈U型分布，拥有深水海岸线585米，主副码头共建有11个泊位:
          10万吨级2个、2万吨级1个、5千吨级1个、3千吨级2个、2千吨级5个，其中2个泊位结构按10万吨级设计建造，最大可停靠10万吨级油轮，充分满足各种吨位油轮需要，年设计吞吐能力1236万吨。目前为珠三角地区规模最大，设备最先进的专业石油化工品装卸码头，主要经营范围为石油化工产品的装卸、中转和仓储。
        </p>
      </div>

      <div class="container1">
        <div class="item1"><img src="../assets/11.png" /></div>
        <div class="item1"><img src="../assets/22.png" /></div>
      </div>
    </div>

    <div class="article">
      <div class="title_tip">
        <div class="title_top">
          <div class="title_left">合作伙伴</div>
          <div class="title_right">
            <div>COOPERATION</div>
            <div>PARTNERS</div>
          </div>
        </div>
        <div class="title_bottom"></div>
      </div>

      <div class="container py">
        <div class="item"><img src="../assets/py1.png" /></div>
        <div class="item"><img src="../assets/py2.png" /></div>
        <div class="item"><img src="../assets/py3.png" /></div>
        <div class="item"><img src="../assets/py4.png" /></div>
        <div class="item"><img src="../assets/py5.png" /></div>
        <div class="item"><img src="../assets/py6.png" /></div>
        <div class="item"><img src="../assets/py7.png" /></div>
        <div class="item"><img src="../assets/py8.png" /></div>
        <div class="item"><img src="../assets/py9.png" /></div>
        <div class="item"><img src="../assets/py10.png" /></div>
        <div class="item"><img src="../assets/py11.png" /></div>
        <div class="item"><img src="../assets/py12.png" /></div>
        <div class="item"><img src="../assets/py13.png" /></div>
        <div class="item"><img src="../assets/py14.png" /></div>
        <div class="item"><img src="../assets/py15.png" /></div>
        <div class="item"><img src="../assets/py16.png" /></div>
      </div>
    </div>
  </div>


</template>

<script>

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.head_bg {
  display: flex;
  flex-direction: row;
}

.head_bg img {
  flex: 1;
  min-width: 100%;
}

.article {
  font-size: 0.45rem;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 0.8rem;
}

.title_tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100%;
}

.title_top {
  min-width: 100%;
  display: flex;
  flex-direction: row;
  gap: 3px;
  justify-content: flex-start;
}

.title_left {
  color: #1167b3;
  font-weight: bold;
  font-size: 0.6rem;
}

.title_right {
  display: flex;
  flex-direction: column;
  font-size: 0.3rem;
  color: #1167b3;
  justify-content: center;
}

.title_bottom {
  height: 3px;
  width: 100%;
  background: url("../assets/title_bottom.png") no-repeat left top #1167b3;
}

.substance {
  min-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.substance p {
  text-indent: 2em;
}

.article_content_p {
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  text-indent: 2em;
}

.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.1rem;
}

.item {
  width: 46%;
  display: flex;
}

.item img {
  min-width: 100%;
}

.container1 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.2rem;
}

.item1 {
  display: flex;
  width: 100%;
}

.item2 {
  display: flex;
  width: 100%;
}

.item1 img {
  min-width: 100%;
}

.item2 img {
  min-width: 100%;
}

.py {
  gap: 0.6rem;
}
</style>
